import Box from '@mui/material/Box';
import { SectionTitle, Subsection } from '../components/SectionPrimitives';

export function Section11(): JSX.Element {
  return (
    <Box>
      <SectionTitle>11. Contact Information</SectionTitle>

      <Subsection title="11.1 Contacting UKVG">
        For enquiries regarding the Agreement, these Terms, or any aspect of the
        services, Partners should contact UKVG using the contact form available
        on the UK Vineyard Guide website or by email to the address provided at
        the start of any formal correspondence.
      </Subsection>

      <Subsection title="11.2 Notices">
        All notices required under the Agreement shall be in writing and
        delivered personally, by email, or by registered post to the address of
        the receiving party as set out in the agreement documentation. Notices
        shall be deemed received on the date of delivery if delivered
        personally, on the date of sending if sent by email with read receipt,
        or five business days after posting if sent by registered post.
      </Subsection>
    </Box>
  );
}
